<smrts-page primaryTitle="Vistorias">

  <div header class="header-container">

    <p-floatLabel variant="on" class="busca-vistoria-field">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input pInputText id="buscarVistoria" class="busca-vistoria-input" (input)="filtrar($any($event.target).value)" />
      </p-iconField>
      <label for="buscarVistoria">Buscar</label>
    </p-floatLabel>

    <button mat-flat-button class="white-text-button btn-nova-vistoria" matTooltip="Nova vistoria" (click)="popoverNova.toggle($event)">
      <i class="pi pi-plus button-menu-icon"></i>
      <span class="btn-nova-vistoria-label">Nova</span>
    </button>

    <p-popover #popoverNova appendTo="body">
      <div class="popover-nova-content">
        <app-generic-autocomplete
          [items]="modelos"
          displayField="nome"
          label="Buscar modelo"
          inputId="modeloParaNovaVistoria"
          [ngModel]="null"
          (selectionChange)="selecionarModeloClick($event); popoverNova.hide()">
        </app-generic-autocomplete>

        <button mat-stroked-button class="btn-sem-modelo" (click)="iniciarSemModeloClick(); popoverNova.hide()">
          Iniciar sem modelo
        </button>
      </div>
    </p-popover>

  </div>

  <div class="content">

    <mat-card class="main-card">

      <p-table #dt [value]="vistorias" dataKey="id" class="vistorias-table"
        [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]"
        [globalFilterFields]="['endereco', 'vistoriador', 'modeloVistoriaNome']">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="endereco">Endereço<p-sortIcon field="endereco"></p-sortIcon></th>
            <th pSortableColumn="vistoriador">Vistoriador<p-sortIcon field="vistoriador"></p-sortIcon></th>
            <th pSortableColumn="data">Data<p-sortIcon field="data"></p-sortIcon></th>
            <th pSortableColumn="modeloVistoriaNome">Modelo<p-sortIcon field="modeloVistoriaNome"></p-sortIcon></th>
            <th pSortableColumn="quantidadeFotos">Quantidade de fotos<p-sortIcon field="quantidadeFotos"></p-sortIcon></th>
            <th pSortableColumn="situacao">Situação<p-sortIcon field="situacao"></p-sortIcon></th>
            <th class="coluna-acoes"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.endereco }}</td>
            <td>{{ item.vistoriador }}</td>
            <td>{{ item.data | date: 'dd/MM/yyyy' }}</td>
            <td>{{ item.modeloVistoriaNome ?? 'Sem modelo' }}</td>
            <td>{{ item.quantidadeFotos }}</td>
            <td>{{ nomeSituacao(item.situacao) }}</td>
            <td>
              <button mat-icon-button matTooltip="Editar" (click)="editarClick(item)">
                <i class="pi pi-pencil"></i>
              </button>
              <button mat-icon-button matTooltip="Remover" [disableNoPermission]="permissaoRealizarVistoria" (click)="removerClick(item)">
                <i class="pi pi-trash"></i>
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">Nenhuma vistoria cadastrada</td>
          </tr>
        </ng-template>

      </p-table>

    </mat-card>

  </div>

</smrts-page>
